<template>
  <b-table
    :items="orgCountByTypeAndOrgAdmin"
    responsive
    :fields="orgCountByTypeAndOrgAdminFields"
    class="mb-0"
  >
    <template #head()="data">
      {{ $t(data.label) }}
    </template>

    <template #cell(type_org_id)="data">
      <div class="d-flex align-items-center">
        <b-avatar
          class="mr-1"
          :variant="color[data.index % (color.length)]"
        >
          <feather-icon
            size="18"
            :icon="icons[data.index % (icons.length)]"
          />
        </b-avatar>
        <span>{{ $langName(getOrgType(data.value).name) }}</span>
      </div>
    </template>
    <template #cell(org_count)="data">
      <span class="font-weight-bolder">{{ data.value }}</span>
    </template>
    <template #cell(usr_org_count)="data">
      <span class="font-weight-bolder">{{ data.value }}</span>
    </template>
  </b-table>
</template>

<script>
import { BTable, BAvatar } from 'bootstrap-vue'

export default {
  name: 'OrgCountByTypeAndOrgAdminComponent',
  components: {
    BTable,
    BAvatar,
  },
  data() {
    return {
      color: ['light-primary', 'light-info', 'light-danger', 'light-success', 'light-warning'],
      icons: ['TrendingUpIcon', 'UserIcon', 'BoxIcon', 'BriefcaseIcon', 'ActivityIcon'],
    }
  },
  computed: {
    orgCountByTypeAndOrgAdmin() {
      return this.$store.state[this.MODULE_NAME].orgCountByTypeAndOrgAdmin
    },
  },
  created() {
    this.$store.dispatch(`${this.MODULE_NAME}/orgCountByTypeAndOrgAdmin`)
  },
  methods: {
    getOrgType(type) {
      return this.$store.getters['staticModule/getOrgType'](type)
    },
  },
  setup() {
    const orgCountByTypeAndOrgAdminFields = [
      { key: 'type_org_id', label: 'Type Org', thClass: 'h6' },
      { key: 'org_count', label: 'Org count', thClass: 'h6' },
      { key: 'usr_org_count', label: 'Count of attached admins', thClass: 'h6' },
    ]
    const MODULE_NAME = 'statistic'
    return {
      orgCountByTypeAndOrgAdminFields,
      MODULE_NAME,
    }
  },
}
</script>

<style scoped>

</style>
